export const Assets = [
    {
        "url": "/json/piss-shivers-ui.json",
        "name": "piss-shivers-ui"
    }
]